export default __webpack_public_path__ + "static/media/KotakGeneralInsurance.f1d1143a.svg";